import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'fromKioskCartProductMultiModsArray'
})
export class FromKioskCartProductMultiModsArrayPipe implements PipeTransform {
  transform(collection: any[]): string {
    const selectedModifiers = [];

    collection.forEach((modifierGroup) => {
      const modifier = modifierGroup.modifier;
      selectedModifiers.push(modifier);
    });
    return selectedModifiers.length > 0
      ? selectedModifiers.map((x) => '+ ' + x.name.trim()).join(', ')
      : '';
  }
}
